<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-toolbar
                    id="dashboard-toolbar"
                    flat
                >
                    <span class="toolbar-title">Dashboard</span>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row class="mt-0 mb-9">
            <v-col
                cols="6"
                md="4"
                lg="2"
                class="flex-grow-1 flex-shrink-0"
            >
                <DashboardFilterCard
                    link="/tickets"
                    icon-background-color="#FFF8E4"
                    icon-color="#F3A72E"
                    icon="today"
                    label="Today"
                    :content="todayTickets"
                />
            </v-col>
            <v-col
                cols="6"
                md="4"
                lg="2"
                class="flex-grow-1 flex-shrink-0"
            >
                <DashboardFilterCard
                    link="/tickets"
                    icon-background-color="#EAFFEF"
                    icon-color="#2FA84F"
                    icon="confirmation_number"
                    label="Open"
                    :content="openTickets"
                />
            </v-col>
            <v-col
                cols="6"
                md="4"
                lg="2"
                class="flex-grow-1 flex-shrink-0"
            >
                <DashboardFilterCard
                    link="/tickets"
                    icon-background-color="rgba(0, 172, 193, .1)"
                    icon-color="#00ACC1"
                    icon="note_alt"
                    label="Un - Assigned"
                    :content="unAssignedTickets"
                />
            </v-col>
            <v-col
                cols="6"
                md="4"
                lg="2"
                class="flex-grow-1 flex-shrink-0"
            >
                <DashboardFilterCard
                    link="/tickets"
                    icon-background-color="rgba(25, 118, 210, .1)"
                    icon-color="#1976D2"
                    icon="assignment_turned_in"
                    label="Assigned"
                    :content="assignedTickets"
                />
            </v-col>
            <v-col
                cols="6"
                md="4"
                lg="2"
                class="flex-grow-1 flex-shrink-0"
            >
                <DashboardFilterCard
                    link="/tickets"
                    icon-background-color="rgba(244, 67, 54, .1)"
                    icon-color="#FF0000"
                    icon="notification_important"
                    label="Emergency"
                    :content="emergencyTickets"
                />
            </v-col>
            <v-col
                cols="6"
                md="4"
                lg="2"
                class="flex-grow-1 flex-shrink-0"
            >
                <DashboardFilterCard
                    link="/tickets"
                    icon-background-color="rgba(161, 69, 246, .1)"
                    icon-color="#8E24AA"
                    icon="dangerous"
                    label="Damage"
                    :content="damageTickets"
                />
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pt-0"
            >
                <v-sheet
                    color="white"
                    height="auto"
                    rounded
                    class="my-2"
                >
                    <v-card
                        elevation="2"
                        outlined
                        class="pa-5"
                    >
                        <v-card-title>Today - {{ todayTickets }} tickets</v-card-title>
                        <v-card-subtitle>{{ todaysDate }}</v-card-subtitle>
                        <TodaysTicketGraph :chart-data="todaysTicketGraphData" />
                    </v-card>
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pt-0"
            >
                <v-sheet
                    color="white"
                    height="auto"
                    rounded
                    class="my-2"
                >
                    <TicketRecentEmergencyTotals :recent-emergency-data="recentEmergencyData" />
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pt-0"
            >
                <v-sheet
                    color="white"
                    height="auto"
                    rounded
                    class="my-2"
                >
                    <PriorityTypeCategoryTotals :priority-data="priorityData" />
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pt-0"
            >
                <v-sheet
                    color="white"
                    height="auto"
                    rounded
                    class="my-2"
                >
                    <TicketCountiesTotals :county-data="ticketCounties" />
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pt-0"
            >
                <v-sheet
                    color="white"
                    height="auto"
                    rounded
                    class="my-2"
                >
                    <TicketMemberCodeTotals :member-data="overviewMembers" />
                </v-sheet>                
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pt-0"
            >
                <v-sheet
                    color="white"
                    height="auto"
                    rounded
                    class="my-2"
                >
                    <LocatorAssigned :locator-data="locatorAssigned" />
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import DashboardFilterCard from '@/components/DashboardFilterCard';
import TodaysTicketGraph, { parseTodaysTicketGraphData } from '@/components/TodaysTicketGraph';
import TicketCountiesTotals, { formatTicketCounties } from '@/components/TicketCountiesTotals';
import LocatorAssigned from '@/components/LocatorAssigned';
import TicketRecentEmergencyTotals, { formatRecentEmergencyTicketsData } from '@/components/TicketRecentEmergencyTotals';
import PriorityTypeCategoryTotals from '@/components/PriorityTypeCategoryTotals';
import TicketMemberCodeTotals from '@/components/TicketMemberCodeTotals';
import webtmsBackend from '../services/webtmsBackend';

export default {
    components: {
        DashboardFilterCard,
        TodaysTicketGraph,
        TicketCountiesTotals,
        LocatorAssigned,
        TicketRecentEmergencyTotals,
        PriorityTypeCategoryTotals,
        TicketMemberCodeTotals,
    },
    data() {
        return {
            todayTickets: 0,
            openTickets: 0,
            unAssignedTickets: 0,
            assignedTickets: 0,
            emergencyTickets: 0,
            damageTickets: 0,
            ticketCounties: [],
            locatorAssigned: [],
            todaysTicketGraphData: {},
            priorityData: [],
            overviewMembers: [],
            ticketClassesTotals: {},
            recentEmergencyData: [],
        };
    },
    computed: {
        todaysDate() {
            const date = new Date();
            const month = date.toLocaleString('default', { month: 'long' });

            return `${date.getDate()} ${month} ${date.getFullYear()}`;
        },
    },
    async mounted() {
        const {
            overviewOpenTickets,
            ticketsReceivedToday,
            counties,
            recentEmergencyTickets,
        } = await webtmsBackend.getDashboardData();
        this.todayTickets = overviewOpenTickets.ticketsReceivedToday;
        this.openTickets = overviewOpenTickets.overviewStage.OPEN;
        this.unAssignedTickets = overviewOpenTickets.overviewStage.IR;
        this.assignedTickets = overviewOpenTickets.overviewStage.AL;
        this.emergencyTickets = overviewOpenTickets.overviewStage.EMERGENCY;
        this.damageTickets = overviewOpenTickets.overviewStage.DAMAGE;

        this.ticketCounties = formatTicketCounties(counties, overviewOpenTickets.overviewCounties);
        this.todaysTicketGraphData = parseTodaysTicketGraphData(ticketsReceivedToday);
        this.priorityData = overviewOpenTickets.overviewPriority;
        this.overviewMembers = overviewOpenTickets.overviewMembers;
        this.ticketClassesTotals = overviewOpenTickets.overviewStage.TYPES;
        this.locatorAssigned = overviewOpenTickets.overviewAssigned;

        this.recentEmergencyData = formatRecentEmergencyTicketsData(recentEmergencyTickets);
    },
};
</script>
<style>
#dashboard-toolbar .toolbar-title {
    font-size: 20px;
    font-weight: 500;
}
#dashboard-toolbar .v-toolbar__content {
    padding-left: 0;
    padding-right: 0;
}
</style>